import { render, staticRenderFns } from "./BindsDialogAlert.vue?vue&type=template&id=162a8ce9&"
import script from "./BindsDialogAlert.vue?vue&type=script&lang=js&"
export * from "./BindsDialogAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports